import { render, staticRenderFns } from "./LeaveAllowance.vue?vue&type=template&id=560263ae&scoped=true"
import script from "./LeaveAllowance.vue?vue&type=script&lang=js"
export * from "./LeaveAllowance.vue?vue&type=script&lang=js"
import style0 from "./LeaveAllowance.vue?vue&type=style&index=0&id=560263ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560263ae",
  null
  
)

export default component.exports